import React, { useState, useEffect, useMemo } from "react";

import { Fonts } from "../../../constants/fonts";
import { useSelector, useDispatch } from "react-redux";

// import ErrorOverlay from "../../../components/overlays/ErrorOverlay";
// import SuccessOverlay from "../../../components/overlays/SuccessOverlay";
import AddFoulModal from "./components/AddFoulModal";
import { editTeam, updateTeamSetting } from "../../services/team.services.js";
import { UpdateSelectedTeam } from "../../redux/actions/team.actions.js";
import "./personalfoulsettings.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const PersonalFoulSetting = (props) => {
  const dispatch = useDispatch();

  const operatorTeam = useSelector((state) => state.team.selectedTeam);
  const user = useSelector((state) => state.auth.user);
  const rules = operatorTeam?.teamId?.gameRules;

  const [initialFormState, setInitialFormState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [newFoul, setNewFoul] = useState(null);
  const [editIndex, setEditIndex] = useState(null);

  const HeadingText = useMemo(() => {
    return rules?.gender === "female" ? "Yellow Card" : "Personal Fouls";
  }, [rules?.gender]);

  const toggleSuccessModal = () => {
    setSuccessVisible(true);
    setTimeout(() => {
      setSuccessVisible(false);
    }, 2500);
  };

  useEffect(() => {
    const personalOptions = operatorTeam?.teamId?.penalty_options?.find(
      (v) => v.slug === "personal"
    );
    if (personalOptions) {
      setInitialFormState(personalOptions.children);
    }
  }, [operatorTeam?.teamId?.penalty_options]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const updatedOptions = [
        ...initialFormState,
        { displayName: newFoul, slug: newFoul.toLowerCase().replace(/\s+/g, "_") },
      ];
      const updatedPenaltyOptions = operatorTeam.teamId.penalty_options.map(
        (v) => {
          if (v.slug === "personal") {
            return { ...v, children: updatedOptions };
          }
          return v;
        }
      );
      await editTeam(
        {
          teamId: operatorTeam.teamId._id,
          penalty_options: updatedPenaltyOptions,
        },
        user?.token
      );
      toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam._id));
      setNewFoul(null);
      setInitialFormState(null);
    } catch (e) {
      // setError(e);
      console.log("Error at Delete Foul'  ===>", e.response.data);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    if (editIndex === null) return;

    try {
      setLoading(true);
      const updatedOptions = [...initialFormState];
      updatedOptions[editIndex] = {
        displayName: newFoul,
        slug: newFoul.toLowerCase().replace(/\s+/g, "_"),
      };
      const updatedPenaltyOptions = operatorTeam.teamId.penalty_options.map(
        (v) => {
          if (v.slug === "personal") {
            return { ...v, children: updatedOptions };
          }
          return v;
        }
      );
      await editTeam(
        {
          teamId: operatorTeam.teamId._id,
          penalty_options: updatedPenaltyOptions,
        },
        user?.token
      );
      toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam._id));
      setNewFoul(null);
      setEditIndex(null);
      setInitialFormState(null);
      setEditModalVisible(false);
    } catch (e) {
      console.log("Error at Edit Foul'  ===>", e.response.data);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (index) => {
    try {
      setLoading(true);
      const updatedOptions = initialFormState.filter((_, i) => i !== index);
      const updatedPenaltyOptions = operatorTeam.teamId.penalty_options.map(
        (v) => {
          if (v.slug === "personal") {
            return { ...v, children: updatedOptions };
          }
          return v;
        }
      );
      await editTeam(
        {
          teamId: operatorTeam.teamId._id,
          penalty_options: updatedPenaltyOptions,
        },
        user?.token
      );
      toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
      setInitialFormState(updatedOptions);
    } catch (e) {
      // setError(e);
      console.log("Error at Delete Foul'  ===>", e.response.data);
    } finally {
      setLoading(false);
    }
  };

  const handleResetToDefault = async () => {
    if (
      window.confirm(
        "Are you sure you want to reset to default?"
      )
    ) {
      try {
        setLoading(true);
        const settingName = 'penalty_options';
        const teamId = operatorTeam.teamId._id;
        const token = user?.token;
        const PenaltyType = 'Personal';
        await updateTeamSetting(
          settingName, teamId, token, PenaltyType
        );
        toggleSuccessModal();
        dispatch(UpdateSelectedTeam(operatorTeam?._id));
        setInitialFormState([]);
      } catch (e) {
        console.log("Error at Reset Personal Penalty Fouls:", e.response.data);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="container-personal-pen-settings">
      <UserSidebar />
      <header className="settings-rating-header">
        {/* <HeaderBackButton /> */}
        <h1 style={{ color: '#1a2a6c', fontSize: '35px' }}>{HeadingText}</h1>
        <button
          className="defaultBtn-technical-pen-settings"
          onClick={handleResetToDefault}
        >
          Reset to Default
        </button>
        <button
          className="defaultBtn-technical-pen-settings"
          onClick={() => setAddModalVisible(true)}
        >
          Add a Foul
        </button>

      </header>
      {initialFormState && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '50px' }}>
          <div className="foulList-technical-pen-settings">
            {initialFormState.map((foul, index) => (
              <div key={index} className="foulView-technical-pen-settings">
                <p style={{ fontWeight: '600' }}>{foul.displayName}</p>
                <button
                  className="delBtn-technical-pen-settings"
                  onClick={() => handleDelete(index)}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
      {successVisible && (
        <div className="successOverlay-personal-pen-settings">
          Foul updated successfully!
        </div>
      )}
      <AddFoulModal
        onBackdropPress={() => setAddModalVisible(false)}
        visible={addModalVisible}
        newFoul={newFoul}
        setNewFoul={setNewFoul}
        handleSave={handleSave}
        foulModalHeading="Add A Foul Option"
      />
    </div>
  );
};

export default PersonalFoulSetting;
